import { EChartType, IChart, INameAndValue, SingleSeriesData } from '@adaptiva/core/charts';
import { isNullOrUndefined } from '@adaptiva/core/common';
import { AdaColor, DEFAULT_5, ThemeColor } from '@adaptiva/core/themes';
import { UiService } from '@adaptiva/core/ui';
import { BaseWidgetComponent, WidgetService } from '@adaptiva/core/widgets';
import { ICveCounts } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, Input, forwardRef, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ICveCountsDisplay } from './interfaces';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-cve-counts-display',
	templateUrl: './cve-counts-display.component.html',
	providers: [
		WidgetService,
		{ provide: BaseWidgetComponent, useExisting: forwardRef(() => CveCountsDisplayComponent) },
	]
})
export class CveCountsDisplayComponent extends BaseWidgetComponent {

	@Input()
	public cardTitle: string;

	@Input()
	public set cveCounts(_cveCounts: ICveCountsDisplay) {
		if (_cveCounts) {
			this.counts = _cveCounts;
			this._nextChartData(_cveCounts);
		}
	}

	public chartData$: BehaviorSubject<SingleSeriesData> = new BehaviorSubject(null);

	protected readonly totalCveChart: IChart<EChartType.PIE> = {
		chartType: EChartType.PIE,
		config: {
			legendTitle: 'Total CVEs',
			colorPalette: {
				...DEFAULT_5,
				useDefaults: false,
				colorTags: new Map<string, ThemeColor | AdaColor>([
					['Suppressed', 'warning'],
					['Covered', 'success'],
					['Missing', 'error'],
					['Unsupported', 'foreground'],
					['Unregistered', 'foreground']
				]),
				lightStep: 20,
			}
		}
	}

	public counts: ICveCounts;

	protected readonly ui: UiService = inject(UiService);

	private _nextChartData(_counts: ICveCountsDisplay): void {
		const _chartData: INameAndValue[] = [
			{
				name: 'Suppressed',
				value: _counts.suppressed
			},
			{
				name: 'Covered',
				value: _counts.covered
			},
			{
				name: 'Missing',
				value: _counts.missing
			}
		];

		if (!isNullOrUndefined(_counts.unsupported)) {
			_chartData.push({
				name: 'Unsupported',
				value: _counts.unsupported
			});
		}

		if (!isNullOrUndefined(_counts.unregistered)) {
			_chartData.push({
				name: 'Unregistered',
				value: _counts.unregistered
			});
		}

		this.chartData$.next(_chartData);
	}
}
